
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/pandit",
      function () {
        return require("private-next-pages/auth/pandit.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/pandit"])
      });
    }
  